import { useContext, useEffect, useState } from 'react';
import { TaskContext } from '../Insurance';
import { Form } from 'antd';
import { useGetTaskResponsesByTask } from '../../../../services/task/querys';
import { Task, TaskResponse, TaskState } from '../../../../gql/graphql';
import InputBorderNone from '../../components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import ButtonSubmit from '../../components/Atoms/Buttons/ButtonSubmit/ButtonSubmit';
import StateTag from '../../components/Atoms/Tags/StateTag/StateTag';
import ActionAcceptAndReject from '../../../ActionAcceptAndReject/ActionAcceptAndReject';

const Contact = () => {
  const [form] = Form.useForm();
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });

  const [responseInfo, setResponseInfo] = useState<TaskResponse | any>();

  useEffect(() => {
    if (responseInfo && responseInfo.state !== TaskState.RequestError)
      form.setFieldsValue(responseInfo.metadata);
  }, [responseInfo])

  useEffect(() => {
    const _response = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-information');
    setResponseInfo(_response);
  }, [taskResponses]);

  return (
    <div
      id={responseInfo?._id}
      style={{ position: 'relative' }}
      className={`mt-40 title-company-step-1 title-company-step-1-${responseInfo?.state}`}
    >

      {responseInfo &&
        <ActionAcceptAndReject
          taskResponseId={responseInfo?._id}
          task={{ id: task._id, key: task.key, name: task.name }}
          files={responseInfo?.files}
          currentState={responseInfo?.state}
        />
      }

      {responseInfo?.state && responseInfo?.state !== TaskState.Review && <StateTag state={responseInfo?.state} />}
      {responseInfo?.state && responseInfo?.state === TaskState.Review && <StateTag state={responseInfo?.state} isLabelLocked />}

      <Form
        name="edit"
        autoComplete="off"
        requiredMark="optional"
        colon={false}
        form={form}
        disabled={true}
      >
        <Form.Item
          label=""
          name="insuranceCompany"
          className="titleCompany"
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <InputBorderNone
            placeholder="Insurance company name"
            className="bold"
          />
        </Form.Item>
        <Form.Item
          label="Contact name"
          name="name"
          className="name"
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <InputBorderNone
            placeholder="Nicolas Ortiz"
            height={20}
            className="bold-lith"
          />
        </Form.Item>

        <Form.Item
          label="Phone number"
          name="phone"
          className="phone"
          rules={[
            { required: true, message: 'Phone number is required' },
            { min: 12, message: '' }
          ]}
        >
          <InputBorderNone
            placeholder="203-423-3534"
            height={20}
            className="bold-lith"
          />
        </Form.Item>

        <Form.Item
          label="Email address"
          name="email"
          className="email"
          rules={[{ required: true, type: 'email', message: 'Invalid email address' }]}
        >
          <InputBorderNone
            type="email"
            placeholder="lend@constlending.com"
            height={20}
          />
        </Form.Item>

        {responseInfo?.state !== TaskState.Approved &&
          <Form.Item className="submit" shouldUpdate>
            {() => (
              <ButtonSubmit
                disabled={true}
                loading={false}
                modalConfirm={{ show: true }}
                onClick={() => { }}
              >
                Submit for review
              </ButtonSubmit>
            )}
          </Form.Item>
        }
      </Form>
    </div>
  );
};
export default Contact;
